import {
  faHome,
  faUser,
  faKey,
  faSearch,
  faUserPlus,
  faFileInvoiceDollar,
  faChartPie,
  faCogs,
  faCode,
  faIdCard,
  faChartBar,
  faBusinessTime,
  faUsers,
  faMoneyBillWave,
  faFolder,
  faEnvelope,
  faUserSlash
} from '@fortawesome/free-solid-svg-icons';
import { Menu } from '../utils/constants/enums';
import { IRoutePermission } from '../utils/constants/interfaces';
import { Permissions } from '../utils/constants/permissions';

export const routePermissions: IRoutePermission[] = [
  {
    path: '/',
    requiredPermissions: [Permissions.APP_USER],
    iconClass: faHome,
    text: 'Home',
    menu: Menu.SIDEBAR
  },
  {
    path: '/members',
    // MemberReadOnly OR MemberUpdate - handled in useAuthorization hasRoutePermission
    requiredPermissions: [Permissions.MEMBER_READ_ONLY, Permissions.MEMBER_UPDATE],
    iconClass: faSearch,
    text: 'Member Search',
    menu: Menu.SIDEBAR
  },
  {
    path: '/members/add',
    requiredPermissions: [Permissions.MEMBER_UPDATE],
    iconClass: faUserPlus,
    text: 'Add New Member',
    menu: Menu.SIDEBAR
  },
  {
    // Billing links directly to Manage Invoices: GEN_INVOICE only
    path: '/billing/invoices',
    requiredPermissions: [Permissions.GEN_INVOICE],
    iconClass: faFileInvoiceDollar,
    text: 'Billing',
    menu: Menu.SIDEBAR
  },
  {
    path: '/',
    // Reports - all visible to any logged in user (children sorted alphabetically by text)
    requiredPermissions: [Permissions.APP_USER],
    iconClass: faChartPie,
    text: 'Reports',
    menu: Menu.SIDEBAR,
    children: [
      {
        path: '/reports/attrition-report',
        // Financial/balance data - MEMBER_UPDATE only (matches API authorization)
        requiredPermissions: [Permissions.MEMBER_UPDATE],
        iconClass: faUserSlash,
        text: 'Attrition Report',
        menu: Menu.SIDEBAR
      },
      {
        path: '/billing/invoice-report',
        // Invoice Report: MEMBER_UPDATE only (per Java app - not GEN_INVOICE)
        requiredPermissions: [Permissions.MEMBER_UPDATE],
        iconClass: faChartBar,
        text: 'Invoice Report',
        menu: Menu.SIDEBAR
      },
      {
        path: '/reports/membership-report',
        // Any logged in user
        requiredPermissions: [Permissions.APP_USER],
        iconClass: faUsers,
        text: 'Membership Report',
        menu: Menu.SIDEBAR
      },
      {
        path: '/reports/payment-report',
        // Any logged in user
        requiredPermissions: [Permissions.APP_USER],
        iconClass: faMoneyBillWave,
        text: 'Payment Report',
        menu: Menu.SIDEBAR
      },
      {
        path: '/reports/work-hours-report',
        // Any logged in user - editing requires WORKHOURS_UPDATE
        requiredPermissions: [Permissions.APP_USER],
        iconClass: faBusinessTime,
        text: 'Work Hours Report',
        menu: Menu.SIDEBAR
      }
    ]
  },
  {
    path: '/',
    // System Utilities - only show to SYSADMIN
    requiredPermissions: [Permissions.SYSADMIN],
    iconClass: faCogs,
    text: 'System Utilities',
    menu: Menu.SIDEBAR,
    children: [
      {
        path: '/codes',
        requiredPermissions: [Permissions.SYSADMIN],
        iconClass: faCode,
        text: 'Codes',
        menu: Menu.SIDEBAR
      },
      {
        path: '/membership-types',
        requiredPermissions: [Permissions.SYSADMIN],
        iconClass: faIdCard,
        text: 'Member Types',
        menu: Menu.SIDEBAR
      },
      {
        path: '/files',
        requiredPermissions: [Permissions.SYSADMIN],
        iconClass: faFolder,
        text: 'File Manager',
        menu: Menu.SIDEBAR
      },
      {
        path: '/email-logs',
        requiredPermissions: [Permissions.SYSADMIN],
        iconClass: faEnvelope,
        text: 'Email Log',
        menu: Menu.SIDEBAR
      }
    ]
  },
  {
    path: '/users',
    requiredPermissions: [Permissions.SYSADMIN],
    iconClass: faUser,
    text: 'User Privileges',
    menu: Menu.SIDEBAR
  },
  //ACCOUNT
  {
    path: '/change-password',
    requiredPermissions: [Permissions.APP_USER],
    text: 'Change Password',
    iconClass: faKey,
    menu: Menu.PROFILE
  }
];
